const NoImageSample = () => (
  <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-400">
    <svg
      className="w-10 h-10 mb-1"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 16.5V5.25A2.25 2.25 0 015.25 3h13.5A2.25 2.25 0 0121 5.25v11.25M3 16.5L8.25 12l4.5 4.5L21 9M3 16.5V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18v-1.5"
      />
    </svg>
    <span className="text-xs">No Image</span>
  </div>
)

export default NoImageSample
